/**
 * DETH WELLNESS — Y2K Interactive Effects
 *
 * Modules:
 *  1. Cursor trail (pixel sparkles)
 *  2. Neon cursor ring
 *  3. Random starfield twinkle
 *  4. Auto-marquee for announcement bar
 *  5. Header scroll shadow
 *  6. Active category nav link highlight
 */

(function () {
  'use strict';

  // -------------------------------------------------------------------------
  // 1. CURSOR TRAIL — pixel sparkle dots
  // -------------------------------------------------------------------------
  const CursorTrail = {
    colors: ['#FFFFFF', '#E5E5E5', '#CCCCCC'],
    pool: [],
    active: [],

    init() {
      if (window.matchMedia('(pointer: coarse)').matches) return; // skip touch

      // Pre-create 30 trail dots
      for (let i = 0; i < 30; i++) {
        const el = document.createElement('div');
        el.style.cssText = `
          position: fixed;
          width: 6px;
          height: 6px;
          pointer-events: none;
          z-index: 99999;
          border-radius: 50%;
          opacity: 0;
          transition: opacity 0.1s;
        `;
        document.body.appendChild(el);
        this.pool.push(el);
      }

      let i = 0;
      document.addEventListener('mousemove', (e) => {
        const dot = this.pool[i % this.pool.length];
        i++;

        const color = this.colors[Math.floor(Math.random() * this.colors.length)];
        dot.style.left = e.clientX - 3 + 'px';
        dot.style.top  = e.clientY - 3 + 'px';
        dot.style.background = color;
        dot.style.boxShadow  = `0 0 6px ${color}`;
        dot.style.opacity    = '1';
        dot.style.transform  = 'scale(1)';

        setTimeout(() => {
          dot.style.opacity   = '0';
          dot.style.transform = 'scale(0)';
        }, 350);
      }, { passive: true });
    }
  };

  // -------------------------------------------------------------------------
  // 2. NEON CURSOR RING
  // -------------------------------------------------------------------------
  const CursorRing = {
    el: null,
    x: 0, y: 0,
    tx: 0, ty: 0,

    init() {
      if (window.matchMedia('(pointer: coarse)').matches) return;

      this.el = document.createElement('div');
      this.el.style.cssText = `
        position: fixed;
        width: 28px;
        height: 28px;
        border: 2px solid #FFFFFF;
        border-radius: 50%;
        pointer-events: none;
        z-index: 99998;
        transform: translate(-50%, -50%);
        transition: border-color 200ms ease, box-shadow 200ms ease;
        box-shadow: 0 0 8px #FFFFFF, 0 0 16px rgba(255,255,255,0.4);
        mix-blend-mode: screen;
      `;
      document.body.appendChild(this.el);

      document.addEventListener('mousemove', (e) => {
        this.tx = e.clientX;
        this.ty = e.clientY;
      }, { passive: true });

      // Change ring color on hovering links/buttons
      document.addEventListener('mouseover', (e) => {
        if (!this.el) return;
        const isInteractive = e.target.closest('a, button, .button, input, select');
        if (isInteractive) {
          this.el.style.borderColor = '#FFFFFF';
          this.el.style.boxShadow = '0 0 8px #FFFFFF, 0 0 16px rgba(255,255,255,0.5)';
          this.el.style.transform = 'translate(-50%, -50%) scale(1.5)';
        } else {
          this.el.style.borderColor = '#FFFFFF';
          this.el.style.boxShadow = '0 0 8px #FFFFFF, 0 0 16px rgba(255,255,255,0.4)';
          this.el.style.transform = 'translate(-50%, -50%) scale(1)';
        }
      });

      this.animate();
    },

    animate() {
      this.x += (this.tx - this.x) * 0.18;
      this.y += (this.ty - this.y) * 0.18;
      if (this.el) {
        this.el.style.left = this.x + 'px';
        this.el.style.top  = this.y + 'px';
      }
      requestAnimationFrame(() => this.animate());
    }
  };

  // -------------------------------------------------------------------------
  // 3. STARFIELD TWINKLE
  // -------------------------------------------------------------------------
  const StarTwinkle = {
    init() {
      const stars = document.querySelectorAll('.y2k-star');
      if (!stars.length) return;
      stars.forEach(star => {
        const delay = Math.random() * 3;
        const duration = 1 + Math.random() * 2;
        star.style.animation = `y2kStarTwinkle ${duration}s ${delay}s ease-in-out infinite alternate`;
      });
    }
  };

  // Inject twinkle keyframes
  const twinkleStyle = document.createElement('style');
  twinkleStyle.textContent = `
    @keyframes y2kStarTwinkle {
      from { opacity: 0.2; transform: scale(0.8); }
      to   { opacity: 1;   transform: scale(1.2); }
    }
  `;
  document.head.appendChild(twinkleStyle);

  // -------------------------------------------------------------------------
  // 4. ANNOUNCEMENT BAR — auto marquee
  // -------------------------------------------------------------------------
  const AnnouncementMarquee = {
    init() {
      const bar = document.querySelector('.announcement-bar__message');
      if (!bar) return;

      const text = bar.textContent.trim();
      if (!text) return;

      const spacer = '&nbsp;&nbsp;★&nbsp;&nbsp;';
      const repeated = `${text}${spacer}${text}${spacer}${text}${spacer}`;
      bar.innerHTML = `<span class="y2k-marquee-inner">${repeated}</span>`;
      bar.style.overflow = 'hidden';
      bar.style.whiteSpace = 'nowrap';
    }
  };

  // -------------------------------------------------------------------------
  // 5. HEADER — shadow on scroll (disabled, no header line)
  // -------------------------------------------------------------------------
  const HeaderScroll = {
    init() {}
  };

  // -------------------------------------------------------------------------
  // 6. CATEGORY NAV — highlight active based on current URL
  // -------------------------------------------------------------------------

  // -------------------------------------------------------------------------
  // 7. PARALLAX PEEK — section that pokes above the footer at a slower scroll rate
  // -------------------------------------------------------------------------
  const ParallaxPeek = {
    init() {
      const peek = document.querySelector('.deth-parallax-peek');
      const footer = document.querySelector('footer.footer');
      if (!peek || !footer) return;

      // Footer always overlaps this many px of the peek's bottom edge.
      // Peek height starts at OVERLAP (nothing visible above footer).
      // As progress → 1, up to MAX_EXTRA px of white rises above the footer.
      const OVERLAP   = 20;
      const MAX_EXTRA = 120;

      footer.style.marginTop = `-${OVERLAP}px`;
      footer.style.position  = 'relative';
      footer.style.zIndex    = '3';

      const heroPeek = document.querySelector('.deth-hero-peek');
      const HERO_MAX = 120;
      // Scroll distance (px) over which the hero hole closes. Using a fixed range
      // instead of viewport height keeps the close speed consistent across
      // devices — otherwise a short mobile viewport delays the close start.
      const HERO_RANGE = 800;
      const testimonials = document.querySelector('.deth-testimonials');

      // How aggressively the testimonials section lags the scroll (travel/rate).
      const TESTIMONIALS_RATE = 0.05;
      // Constant baseline shift (px) applied as a transform. Keep at 0 — the
      // resting overlap with the product grid is done via negative margin in
      // CSS (.deth-testimonials margin-top) so how-it-works follows in layout
      // and stays close to the testimonials' bottom.
      const TESTIMONIALS_BASE = 0;

      let ticking = false;

      function update() {
        const viewH = window.innerHeight;

        // Footer peek
        const rect = peek.getBoundingClientRect();
        const progress = Math.max(0, Math.min(1, (viewH - rect.top) / viewH));
        peek.style.height = (OVERLAP + MAX_EXTRA * progress) + 'px';

        if (heroPeek) {
          const heroRect = heroPeek.getBoundingClientRect();
          const heroProgress = Math.max(0, Math.min(1, heroRect.top / HERO_RANGE));
          heroPeek.style.height = (HERO_MAX * heroProgress) + 'px';
        }

        if (testimonials) {
          const tRect = testimonials.getBoundingClientRect();
          const offset = (tRect.top + tRect.height / 2 - viewH / 2) * TESTIMONIALS_RATE + TESTIMONIALS_BASE;
          testimonials.style.transform = `translateY(${offset}px)`;
        }
        ticking = false;
      }

      function onScroll() {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(update);
        }
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      update();
    }
  };

  // -------------------------------------------------------------------------
  // 9. CONTENT PANEL — wrap shop / testimonials / how-it-works in one container
  //    so they share a single background image.
  // -------------------------------------------------------------------------
  const SectionWrapper = {
    init() {
      const shopEl         = document.querySelector('.deth-shop')?.closest('.shopify-section');
      const testimonialsEl = document.querySelector('.deth-testimonials')?.closest('.shopify-section');
      const howEl          = document.querySelector('.deth-how')?.closest('.shopify-section');
      if (!shopEl || !testimonialsEl || !howEl) return;

      // Note: the video-loop section is intentionally left OUT of the panel so
      // it sits as its own section directly below it.
      const wrapper = document.createElement('div');
      wrapper.className = 'deth-content-panel';
      shopEl.parentNode.insertBefore(wrapper, shopEl);
      wrapper.appendChild(shopEl);
      wrapper.appendChild(testimonialsEl);
      wrapper.appendChild(howEl);
    }
  };

  // -------------------------------------------------------------------------
  // 8. BACKGROUND PARALLAX — counter-scroll the site's tiled background so it
  //    stays fixed to the viewport, same "infinite canvas" effect as the peeks.
  // -------------------------------------------------------------------------
  const BackgroundParallax = {
    init() {
      const root = document.documentElement;
      // On product pages the full-page background is held fixed via CSS
      // (background-attachment: fixed); don't counter-scroll it here or the two
      // would fight and jitter. The homepage content panel is likewise held
      // fixed via CSS, so no JS background tracking is needed for it either.
      if (root.dataset.pageType === 'product') return;

      // How fast the tiled background moves relative to scroll.
      //   1  = fully counter-scrolls (background appears locked in place)
      //   0  = scrolls normally with the page (no parallax)
      //   between 0 and 1 = drifts slowly (partial parallax)
      //   > 1 = moves faster than the page
      const BG_PARALLAX_RATE = 0.2;

      let ticking = false;

      function update() {
        root.style.backgroundPositionY = `-${window.scrollY * BG_PARALLAX_RATE}px`;
        ticking = false;
      }

      function onScroll() {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(update);
        }
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      update();
    }
  };

  // -------------------------------------------------------------------------
  // INIT
  // -------------------------------------------------------------------------
  function init() {
    SectionWrapper.init();
    BackgroundParallax.init();
    CursorTrail.init();
    CursorRing.init();
    StarTwinkle.init();
    AnnouncementMarquee.init();
    HeaderScroll.init();
    ParallaxPeek.init();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
